import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/galactic-75.css";
import "@/sectors-header-left.css";
import "@/why-carthy-video";
import "@/compliance-video";
import "@/sectors-video";
import "@/offscreen-effects-manager";
import "@/ui-cleanup";
import "@/language-default";
import "@/language-switcher-v2";
import "@/contact-actions-cleanup";
import "@/hyperspeed-performance-manager";
import "@/smooth-anchor-scroll";
import "@/mobile-video-background.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
